import HttpClientToken from '../../services/HttpClientToken';

import { ClaseExhortoProps, defaultClaseExhorto } from '../../interfaces/catalogos/ClaseExhortoInterface';

export const ClaseExhorto = () => {

    return new Promise<ClaseExhortoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/ClaseExhorto/', token)
            .then( ({ data } : { data : ClaseExhortoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerClaseExhorto = () => {

    return new Promise<ClaseExhortoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/ClaseExhorto/ObtenerClaseExhorto', token)
            .then( ({ data } : { data : ClaseExhortoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarClaseExhorto = ( params: ClaseExhortoProps ) => {

    return new Promise<ClaseExhortoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ClaseExhorto/Actualizar', params, token)
            .then( ({ data } : { data : ClaseExhortoProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultClaseExhorto } );
            });

        }

    });

}

export const AgregarClaseExhorto = ( params: ClaseExhortoProps ) => {

    return new Promise<ClaseExhortoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ClaseExhorto/Agregar', params, token)
            .then( ({ data } : { data : ClaseExhortoProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultClaseExhorto } );
            });

        }

    });

}
